import { IResultRequestModel } from '../../models/requests/ResultRequestModel'
import { IResultModel } from '../../models/responses/ResultModel'
import { PagedResponseModel } from '../../models/responses/PagedResponseModel'
import { IPaginationFilter, generateQueryParams } from '../../models/requests/PaginationFilter'
import API from './Api'
import { IJobInterviewReportModel } from '../../models/responses/JobInterviewReportModel'

class ResultApi {
  async GetResults(filter: IPaginationFilter) {
    return await API.get<PagedResponseModel<IResultModel[]>>(`ex/CompanyManager/Results${generateQueryParams(filter)}`)
  }

  async GetResult(id: string) {
    return await API.get<IResultModel>('ex/CompanyManager/Results/' + id)
  }

  async GetJobInterviewReport(studentId: string, levelId: number) {
    return await API.get<IJobInterviewReportModel>(`ex/CompanyManager/Results/JobInterviewReport/${studentId}/${levelId}`)
  }

  async UpdateResult(model: IResultRequestModel) {
    return await API.put('ex/CompanyManager/Results/' + model.id, model)
  }

  async DeleteResult(itemId: string) {
    return await API.delete<boolean>('ex/CompanyManager/Results/' + itemId)
  }
}

export default new ResultApi()
